import { render, staticRenderFns } from "./SquareImageCropper.vue?vue&type=template&id=681f2fc8&"
import script from "./SquareImageCropper.vue?vue&type=script&lang=js&"
export * from "./SquareImageCropper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports